import { useTranslation } from 'react-i18next';
import ownerPhoto from '../static/images/owner_section.jpg';
import { Link } from 'react-router-dom';

const HomepageOwnerSection = () => {
    const { t, i18n } = useTranslation();
    return (
        <div className="w-full lg:w-[1000px] h-[400px] md:h-[900px] rounded-xl mt-16 flex justify-center items-center relative bg-cover bg-center" style={{ backgroundImage: `url(${ownerPhoto})` }}>
            <div className='absolute top-[180px] md:top-[600px] right-0 bottom-0 left-0 bg-gradient-to-t from-slate-900 to-transparent p-4 flex flex-col justify-end items-center rounded-xl'>
                <div className="flex flex-col md:flex-row gap-0 items-center mb-4">
                    <div className='text-white text-2xl mt-4 font-bold'>{t('Homepage.HomepageOwnerSection.handleActivity')}</div>
                    <div className="flex items-center">
                        <div className={`font-signature text-[#b05704] text-3xl md:text-7xl flex justify-center ${i18n.language === 'it' || i18n.language === 'en' ? 'mx-2' : 'mx-4'}`}>{t('Homepage.HomepageOwnerSection.outdoor')}</div>
                        <div className='text-white md:text-4xl md:mt-4 font-bold'>?</div>
                    </div>
                </div>
                <Link to="/partner"><button className='mb-4 py-2 px-4 bg-[#fbd100] rounded-xl text-white'>{t('Homepage.HomepageOwnerSection.becomePartnerButton')}</button></Link>
            </div>
        </div>
    )
}

export default HomepageOwnerSection;